import { render, staticRenderFns } from "./DaccountModal.vue?vue&type=template&id=2a9ac0ba&"
import script from "./DaccountModal.vue?vue&type=script&lang=js&"
export * from "./DaccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports